module.exports = __webpack_public_path__ + "static/media/target-align.891fcd6d.svg";